import { mapState } from "vuex";
import { Toast } from "vant";

export default {
  data() {
    return {
      returnUrl: "",
      detail: {}
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    const { orderId } = this.$route.query;
    this.orderId = orderId || "";
    Toast.loading({
      mask: true,
      message: "加载中...",
      duration: 0
    });
    this.getDetail();
  },
  methods: {
    getDetail() {
      const { orderId } = this;
      this.$store.dispatch("order/signature/queryElectronicReceiptByOrderId", {
        orderId
      }).then((data) => {
        const { isUploadNeedVoucher, receiptOrder } = data;
        this.isUpload = isUploadNeedVoucher;
        this.detail = receiptOrder || {};
      }).finally(() => {
        Toast.clear();
      });
    }
  }
};
